import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { useEffect } from 'react';
import { createWebSocketConnection } from './services/api';
import SignUpPage from './pages/SignUpPage';
import SignInPage from './pages/SignInPage';
import DashboardPage from './pages/DashboardPage';
import PlatformSelectionPage from './pages/PlatformSelectionPage';
import SolverDashboardPage from './pages/SolverDashboardPage';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const { user, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (user) {
      // Initialize WebSocket connection when user is authenticated
      const ws = createWebSocketConnection();
      
      return () => {
        ws.close();
      };
    }
  }, [user]);

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">Loading...</div>;
  }

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-900 text-white">
        <Routes>
          <Route path="/signup" element={!user ? <SignUpPage /> : <Navigate to="/dashboard" />} />
          <Route path="/signin" element={!user ? <SignInPage /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={user ? <DashboardPage /> : <Navigate to="/signin" />} />
          <Route path="/platforms" element={user ? <PlatformSelectionPage /> : <Navigate to="/signin" />} />
          <Route path="/solver" element={user ? <SolverDashboardPage /> : <Navigate to="/signin" />} />
          <Route path="/" element={<Navigate to={user ? "/dashboard" : "/signin"} />} />
        </Routes>
      </div>
    </ErrorBoundary>
  );
}

export default App;
